import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import GTMHelper from '../../../Helpers/gtmHelper';

import { Button } from '../../1_Atoms/Button/Button';
import { AccessoryCard } from '../../2_Molecules/AccessoryCard/AccessoryCard';

export const Accessories = ({ ...props }) => {
    const { year, carline, trim, model, packageCode } = useParams();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation(['accessories', 'general']);

    const gtmHelper = new GTMHelper();

    function handleAddAccessoriesClick(e) {
		e.preventDefault();
        const url = '/'+year+'/'+carline+'/'+trim+'/'+model+'/'+packageCode+'/accessories';

        navigate(url);
        gtmHelper.setGTM({'action':'Add Accessories'}, true, false);
    }

    function EditButton(props) {
        let accessories = sessionStorage.getItem(Constants.SelectedAccessories);
        accessories = JSON.parse(accessories);

        if(accessories && accessories.length > 0) {
            return(<div className="accessory-edit-link"><a  className="mz-link" href="" onClick={handleAddAccessoriesClick}>{t("edit_accessories")}</a></div>);
        }
    }

    function AccessoriesList(props) {
        let availableAccessories = JSON.parse(sessionStorage.getItem(Constants.Accessories));

        let accessories = sessionStorage.getItem(Constants.SelectedAccessories);
        accessories = JSON.parse(accessories);
        const List = []

        console.log(accessories)
        if(accessories && accessories.length > 0) {
            accessories.forEach((accessory) => {
                List.push(<AccessoryCard
                    Accessory={{
                        category: {
                        id: accessory.category.id,
                        title: accessory.category.title,
                        },
                        description: accessory.description,
                        image: accessory.image,
                        name: accessory.name,
                        part_number: accessory.part_number,
                        price: accessory.price,
                        install_cost: accessory.install_cost,
                        price_week: null,
                    }}
                    key={accessory.name}
                    Index={1}
                />)
            })
        } else {
            if(availableAccessories && availableAccessories.rawData.length > 0) {
                return (
                    <div className='mz-accessory--empty'>
                        <p>{t("no_added_accessories")}</p>
                        <a className="mz-link" href="" onClick={handleAddAccessoriesClick}>{t("add_accessories")}</a>
                    </div>
                )
            } else {
                return (
                    <div className='mz-accessory--empty'>
                        <p>{t("no_accessorie_comingsoon")}</p>
                    </div>
                )
            }
        }

        return (
            <div className='mz-accessory--container'>
                {List}
            </div>
        )
    }

    return (
        <div className="mz-summary--accessories">
            <h4>{t("accessories:title")}</h4>

            {
                EditButton()
            }

            <AccessoriesList />
        </div>
    )
};